<template>
  <div class="navbar-outer">
    <nav class="navbar">
      <div class="navbar-logo" v-on:click="gotoTop">
        <svgOGQ/>
      </div>
      <button class="navbar-button" v-on:click="openOCS">
        나도 크리에이터 되기
      </button>
    </nav>
  </div>
</template>

<script>
import svgOGQ from "@/svg/svgOGQ"
export default {
  methods: {
    openOCS() {
      return window.open('https://creators.ogq.me/', '_blank')
    },
    gotoTop() {
      return window.scrollTo(0, 0)
    }
  },
  components: {
    svgOGQ
  }
}
</script>

<style lang="scss" scoped>
.navbar-outer { 
  position: fixed;
  top: 0;
  left: 0;
  // right: 0;
  width: 100%;
  // position: relative;
  background: black;
  // backdrop-filter: blur(2px);
  display: flex;
  z-index: 99;
}
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  @extend .container;
  margin: 0 auto;
  height: 56px;
}
.navbar-logo {
  display: block;
  width: auto;
  height: 15px;
  svg {
    display: block;
    height: 100%;
    width: auto;
  }
}
.navbar-button {
  height: 24px;
  padding: 0 14px;
  border-radius: 14px;
  outline: 0;
  background-color: #FFF;
  border: 0;
  font-size: 11px;
  font-weight: 500;
  color: black;
}
</style>